import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { chevronDownIcon } from '../../icons';

@Component({
    selector: 'app-used-car-equipment-comment',
    template: `
        <section class="used-car-equipment-comment" *ngIf="data" [class.used-car-equipment-comment--clamped]="clampedText">
            <div class="used-car-equipment-comment__conten1t">
                <p [innerHTML]="data" class="used-car-equipment-comment__text"></p>
                <div *ngIf="clampedText">...</div>

                <button class="used-car-equipment-comment__toggle button--as-link" type="button" (click)="onToggle()">
                    {{ (clampedText ? 'buttons.read_more_text' : 'buttons.read_less_text') | translate }}
                    <span class="used-car-equipment-comment__toggle-icon">${chevronDownIcon}</span>
                </button>
            </div>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsedCarEquipmentCommentComponent implements OnInit {
    @Input() data: any;
    clampedText: boolean;
    clampLineNumber = 14;
    equipementDataList: string;

    ngOnInit(): void {
        this.clampedText = this.clampLineNumber < this.data.split('<br>').length;
    }

    onToggle() {
        this.clampedText = !this.clampedText;
    }
}
